import { render, staticRenderFns } from "./AccountTab.vue?vue&type=template&id=797bd732&scoped=true"
import script from "./AccountTab.vue?vue&type=script&lang=js"
export * from "./AccountTab.vue?vue&type=script&lang=js"
import style0 from "./AccountTab.vue?vue&type=style&index=0&id=797bd732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797bd732",
  null
  
)

export default component.exports